export default "__VITE_ASSET__78447199__"